// Axios
import axios from "src/lib/axios"

// --------------------------------------------|| AUTHENTICATION - SERVICES || -------------------------------------------

// Login Service
const doLogin = data => {
  return axios.post("/api/v1/account/sendOtp", { userName: data?.phoneNumber })
}
const setLandingData = data => {
  return axios.post("/api/v1/account/setLandingData", {
    mobileNumber: data?.mobileNumber,
    landingCode: data?.landingCode,
    nationalCode: data?.nationalCode
  })
}

// Register Service
const doRegister = userData => {
  return axios.post("/api/v1/account/register", { mobileNumber: userData?.phoneNumber, nationalCode: userData?.id })
}

const verifyLogin = data => {
  return axios.post("/api/v1/account/loginOtp", data)
}

const verifyRegister = data => {
  return axios.post("/api/v1/account/registerVerify", data)
}

const doLogout = refreshToken => {
  return axios.post("/api/v1/account/logout", { refreshToken })
}

const refreshToken = token => {
  return axios.post("/api/v1/account/refreshToken", { refreshToken: token })
}

const resendRegisterOtp = number => {
  return axios.post("/api/v1/account/resendRegisterOtp", { mobileNumber: number })
}

const emtaLogin = data => {
  return axios.post("/api/v1/account/emtaLogin", { userName: "0902474848313", domainAddress: "https://www.test.com" })
}

const verifyEmtaLogin = data => {
  return axios.post("/api/v1/account/emtaConfirm", data)
}

const Authentication = {
  doLogin,
  doRegister,
  verifyLogin,
  verifyRegister,
  doLogout,
  refreshToken,
  resendRegisterOtp,
  emtaLogin,
  verifyEmtaLogin,
  setLandingData
}

export default Authentication
